angular
	.module 'App.Directive'
	.directive 'passwordReveal', ($compile) ->
		restrict: 'A'
		bindToController: true
		scope: {}
		controllerAs: 'passwordReveal'
		controller: ($scope, $element, $timeout, MessageTerminal) ->
			$onInit: ->
				@revealDuration = 5 * 1000

				$element.css('--password-reveal-duration', "#{@revealDuration}ms")
				@input = $element.find('[type="password"]')

				@state = true

			$onDestroy: ->
				$timeout.cancel(@timer)

			onClick: ->
				@state = !@state

				@input.attr('type', if @state then 'password' else 'text')

				if @state == true
					$timeout.cancel(@timer)
				else
					@timer = $timeout(
						=>
							@onClick()
						,
						@revealDuration
					)
